import React from "react";
import { Helmet } from "react-helmet-async";
import { absoluteUrl } from "../seo/siteUrl";

const DEFAULT_OG_IMAGE = "/favicon.png";

/**
 * @param {{
 *   title: string;
 *   description: string;
 *   keywords?: string;
 *   canonicalPath?: string;
 *   noindex?: boolean;
 *   ogImagePath?: string;
 *   ogType?: string;
 *   twitterCard?: string;
 * }} props
 */
const SEOHelmet = ({
  title,
  description,
  keywords,
  canonicalPath,
  noindex,
  ogImagePath = DEFAULT_OG_IMAGE,
  ogType = "website",
  twitterCard = "summary_large_image",
}) => {
  const canonical =
    canonicalPath != null && canonicalPath !== ""
      ? absoluteUrl(canonicalPath)
      : undefined;
  const ogImage = absoluteUrl(ogImagePath.startsWith("/") ? ogImagePath : `/${ogImagePath}`);

  return (
    <Helmet>
      <html lang="en" />
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      {canonical ? <link rel="canonical" href={canonical} /> : null}
      {noindex ? (
        <meta name="robots" content="noindex,nofollow" />
      ) : (
        <meta name="robots" content="index,follow" />
      )}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {canonical ? <meta property="og:url" content={canonical} /> : null}
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:alt" content={title} />
      <meta property="og:locale" content="en_IN" />
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEOHelmet;
